import React from 'react'
import Title from 'shared/components/Title'
import AuthenticationShell from 'shared/components/AuthenticationShell'
import { Link } from 'react-router-dom'
import { Container, Divider } from 'semantic-ui-react'
import Page from 'shared/components/Page'

const InvalidInviteToken = () => (
  <Page>
    <AuthenticationShell
      headerText={
        <>
          <i className="icon far fa-ban" /> Invalid token
        </>
      }
    >
      <Title title="Invalid token" />
      <Container textAlign="center">
        <p className="content-text">
          This invite token is invalid. If you need another one, please contact a Simplesat admin
          from your company.
        </p>
        <Divider hidden />
        <Link to={{ pathname: '/login/', search: location.search }}>
          <i className="fas fa-arrow-left icon" />
          Back to login
        </Link>
      </Container>
    </AuthenticationShell>
  </Page>
)

export default InvalidInviteToken



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/InvalidInviteToken/presentation.js